module.exports = __webpack_public_path__ + "img/wall-clock.442683ae.png";